import styled from 'styled-components';
const CouponRecordStyled = styled.div``;
export default CouponRecordStyled;
